import React from 'react';
import { isSupportReact } from "../const/globalThis";
// 为了确保在一个页面中存在多panda版本，保持同一个panda context，故如果在window对象上已经存在panda context则使用之
// HACK 寻找更好的办法
var localeContext = isSupportReact ? window.__PANDA.pandaContext || /*#__PURE__*/React.createContext({
  locale: {},
  _lang: undefined,
  // 为了保证切换语种的时候内置的组件也有感知，故也需要更改上下文的对象
  lang: undefined,
  $i18n: undefined
}) : {};
// write for global
if (!window.__PANDA.pandaContext || !window.__PANDA.pandaContext.Provider) {
  window.__PANDA.pandaContext = localeContext;
}
export default localeContext;